import React, { useEffect, useState, useRef } from "react";
import SelectColor from "../../Aside2Components/CustomizeComponent/SelectColor";
import { nanoid } from "@reduxjs/toolkit";
import SelectBox from "./FilterConfigCompComponents/SelectBox";

const options = [
  { label: "Equals", value: "Equals" },
  { label: "Does Not Equals", value: "DoesNotEquals" },
  { label: "Greater Than", value: "GreaterThan" },
  { label: "Greater Than Or EqualTo", value: "GreaterThanOrEqualTo" },
  { label: "Less Than", value: "LessThan" },
  { label: "Less Than Or EqualTo", value: "LessThanOrEqualTo" },
  { label: "Between", value: "Between" },
  { label: "Not Between", value: "NotBetween" },
];

export default function CellFormatting({
  rulesArray,
  rule,
  setRulesArray,
  index,
  selectedValue,
  defaultValue,
}) {
  // console.log(rulesArray);
  // console.log(rule);
  const [conditions, setConditions] = useState(rule?.conditions || "LessThan");
  // font color
  const [color, setColor] = useState(
    rule !== undefined ? rule.style?.color : "Black"
  );
  // background
  const [backgroundColor, setBackgroundColor] = useState(
    rule !== undefined ? rule.style?.backgroundColor : "White"
  );
  // minValue
  const [value1, setValue1] = useState(rule !== undefined ? rule?.value1 : "");
  //maxValue
  const [value2, setValue2] = useState(rule !== undefined ? rule?.value2 : "");
  // // console.log(conditions);

  // // console.log(color);

  // // console.log(backgroundColor);

  // // console.log(value1);

  // // console.log(value2);

  const [applyAble, setApplyAble] = useState(false);
  // // console.log(applyAble);

  const handleOperatorChange = (e) => {
    const selected = options.find((option) => option.value === e.target.value);
    // console.log(selected.value);
    setConditions(selected.value);
  };

  const handleDelete = (ruleNanoId) => {
    // console.log(rulesArray);
    const updatedArray = rulesArray.filter((rItem) => rItem.nanoId !== ruleNanoId);
    // console.log(updatedArray);
    setRulesArray(updatedArray);
  };
  const nanoId = nanoid();

  useEffect(() => {
    const updatedRule = {
      measure: selectedValue,
      value1: Number(value1),
      value2: Number(value2),
      conditions: conditions,
      style: {
        backgroundColor: backgroundColor,
        color: color,
      },
      type: "existing",
      nanoId
    };
    // console.log(updatedRule);

    if (
      conditions === "Between" &&
      value1 !== "" &&
      value2 !== "" &&
      Number(value2) > Number(value1)
    ) {
      setApplyAble(true);
      // console.log("Adding new rule in rulesArray");
      const updatedArray = [...rulesArray];
      updatedArray[index] = updatedRule;
      setRulesArray(updatedArray);
    } else if (conditions !== "Between" && value1 !== "") {
      setApplyAble(true);
      // console.log("Adding new rule in rulesArray");
      const updatedArray = [...rulesArray];
      updatedArray[index] = updatedRule;
      // console.log(updatedArray);
      
      setRulesArray(updatedArray);
    } else {
      setApplyAble(false);
    }
  }, [conditions, color, backgroundColor, value1, value2, selectedValue]);

  const renderInputFields = (conditions) => {
    switch (conditions) {
      case "Between":
        return (
          <section className="w-full flex items-center justify-between gap-2 h-full">
            <input
              type="number"
              id="value1"
              className="w-1/2 border rounded border-gray-200 h-full p-1 py-[6px] focus:outline-none"
              required
              placeholder="set min value"
              value={value1}
              onChange={(e) => setValue1(e.target.value)}
            />
            <input
              type="number"
              id="value2"
              className="w-1/2 border rounded border-gray-200 h-full p-1 py-[6px] focus:outline-none"
              required
              placeholder="set max value"
              value={value2}
              onChange={(e) => setValue2(e.target.value)}
            />
          </section>
        );

      default:
        return (
          <section className="flex items-center justify-between gap-2 ">
            <input
              type="number"
              id="singleValue"
              className="w-full border rounded border-gray-200 h-full p-1 py-[6px] focus:outline-none"
              required
              placeholder="set a value"
              value={value1}
              onChange={(e) => setValue1(e.target.value)}
            />
          </section>
        );
    }
  };

  return (
    <section className="flex px-2 items-center pt-1 justify-between w-full h-auto gap-7">
      <div className={`${rulesArray.length > 1 ? `w-[25%]` : `w-[33%]` }`}>
        <SelectBox
          value={conditions}
          onChange={handleOperatorChange}
          optionsArray={options}
        />
      </div>
      <div className={`${rulesArray.length > 1 ? `w-[6%]` : `w-[6%]` }`}>
        <SelectColor
          colorSetter={"textColor"}
          setColor={setColor}
          textColor={color}
          defaultValue={"Black"}
        />
      </div>
      {/* bgColor */}
      <div className={`${rulesArray.length > 1 ? `w-[14%]` : `w-[14%]` }`}>
        <SelectColor
          colorSetter={"bgColor"}
          setBackgroundColor={setBackgroundColor}
          textColor={color}
          backgroundColor={backgroundColor}
        />
      </div>
      <div className={`${rulesArray.length > 1 ? `w-[25%]` : `w-[30%]` }`}>
        {renderInputFields(conditions)}
      </div>
      {rulesArray.length > 1 && (
        <button
          onClick={() => handleDelete(rule?.nanoId)}
          className="border border-gray-200 text-black text-sm font-UberMoveTextMedium w-[12%] p-1 rounded"
          aria-label="Apply conditional formatting"
        >
          Delete
        </button>
      )}
      <button
        className={`text-white text-sm font-UberMoveTextBold p-1 rounded  ${
          applyAble ? "bg-[#17A697] w-[12%]" : "bg-[#F2275D] w-[12%]"
        }`}
      >
        {applyAble ? "Saved" : "Incorrect"}
      </button>
    </section>
  );
}
